import type { ReactNode } from 'react';

interface PartnerCoverProps {
  /** Presigned cover image, or null to show the brand gradient alone. */
  src: string | null;
  className?: string;
  /** Overlaid on the cover (an avatar, a category label); sits above the image. */
  children?: ReactNode;
}

/**
 * A partner's cover band: the brand gradient with the cover photo over it when
 * there is one. Rendered as an `<img>` rather than an inline CSS `url(...)`, so a
 * presigned URL is never interpolated into a style string and a photo that fails
 * to load simply leaves the gradient showing.
 */
export function PartnerCover({ src, className = '', children }: PartnerCoverProps) {
  return (
    <div className={`relative overflow-hidden bg-gradient-to-r from-teal to-teal2 ${className}`.trim()}>
      {src && <img src={src} alt="" className="absolute inset-0 h-full w-full object-cover" />}
      <div className="relative flex h-full items-center justify-center">{children}</div>
    </div>
  );
}
